<template>
  <div class="container page">
    <van-nav-bar :title="$t('setting.login_pwd_tip')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()"/>
      </template>
      <!-- <template #right>
        <span class="nav-right" @click="save()">{{$t("setting.save")}}</span>
      </template> -->
    </van-nav-bar>

    <div class="form-wrapper">
      <div class="form-card">
        <div class="form-item">
          <div class="form-label">{{$t('setting.old_pwd')}}</div>
          <van-field
            v-model="old_password"
            type="password"
            :placeholder="$t('setting.old_pwd_tip')"
            class="form-field"
          />
        </div>
        <div class="form-item">
          <div class="form-label">{{$t('setting.new_pwd')}}</div>
          <van-field
            v-model="o_new_password"
            type="password"
            :placeholder="$t('setting.new_pwd_tip')"
            class="form-field"
          />
        </div>
        <div class="form-item">
          <div class="form-label">{{$t('setting.new_pwd')}}</div>
          <van-field
            v-model="t_new_password"
            type="password"
            :placeholder="$t('setting.new_again_tip')"
            class="form-field"
          />
        </div>
      </div>

      <div class="tip-box">
        <van-icon name="warning-o" color="#ff9800" size="18PX" />
        <span class="tip-text">{{ $t("setting.login_pwd_tip") }}</span>
      </div>

      <van-button 
        class="save-btn" 
        block 
        color="linear-gradient(90deg, #ff5f6d, #ff2d55)" 
        @click="save()"
      >
        {{$t("setting.save")}}
      </van-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      o_new_password: "",
      t_new_password: "",
      old_password: "",
      userInfo: {}
    };
  },
  methods: {
    back() {
      return window.history.back();
    },
    save() {
      if (this.o_new_password === "" || this.o_new_password === null || this.o_new_password === undefined) {
        this.$toast.fail(this.$t("setting.prefect"));
        return false;
      }
      if (this.t_new_password === "" || this.t_new_password === null || this.t_new_password === undefined) {
        this.$toast.fail(this.$t("setting.prefect"));
        return false;
      }
      if (this.old_password === "" || this.old_password === null || this.old_password === undefined) {
        this.$toast.fail(this.$t("setting.prefect"));
        return false;
      }
      if (this.o_new_password !== this.t_new_password) {
        this.$toast(this.$t("setting.pwd_error"));
        return false;
      }
      this.$http({
        method: 'get',
        data: {
          old_password: this.old_password,
          new_password: this.o_new_password,
        },
        url: 'user_set_loginpw'
      }).then(res => {
        if (res.code === 200) {
          this.$toast(res.msg);
          setTimeout(() => {
            localStorage.clear();
            this.$router.push("Login");
          }, 500);
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    getUserInfo() {
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res => {
        if (res.code === 200) {
          this.userInfo = res.data;
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    }
  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push({ path: '/Login' });
    } else {
      this.getUserInfo();
    }
  }
};
</script>

<style lang='less' scoped>
.page {
  min-height: 100VH;
  background: #f7f8fa;
}

/* 顶部导航栏 */
.nav-bar {
  background: #8600ff;
  :deep(.van-nav-bar__title) {
    color: #333;
    font-size: 18PX;
    font-weight: 600;
  }
  :deep(.van-icon) {
    color: #333;
  }
}

.nav-right {
  font-size: 15PX;
  color: #333;
  font-weight: 500;
}

/* 表单区域 */
.form-wrapper {
  padding: 20PX 15PX;
}

/* 表单卡片 */
.form-card {
  background: #fff;
  border-radius: 12PX;
  padding: 15PX;
  box-shadow: 0 4PX 12PX rgba(0, 0, 0, 0.05);
  margin-bottom: 15PX;
}

/* 每个表单项 */
.form-item {
  margin-bottom: 15PX;
}

.form-item:last-child {
  margin-bottom: 0;
}

/* Label 在输入框上方 */
.form-label {
  font-size: 14PX;
  color: #333;
  font-weight: 500;
  margin-bottom: 8PX;
}

.form-field {
  background: #f7f8fa;
  border-radius: 8PX;
  padding: 8PX 12PX;
  :deep(.van-field__control) {
    font-size: 15PX;
    color: #333;
  }
  :deep(.van-field__control::placeholder) {
    font-size: 14PX;
    color: #999;
  }
}

/* 提示信息 */
.tip-box {
  display: flex;
  align-items: flex-start;
  gap: 8PX;
  background: #fff7e6;
  border-radius: 8PX;
  padding: 12PX 15PX;
  margin-bottom: 30PX;
}

.tip-text {
  font-size: 13PX;
  color: #ff9800;
  line-height: 20PX;
  flex: 1;
}

/* 保存按钮 */
.save-btn {
  height: 50PX;
  border-radius: 25PX;
  font-size: 16PX;
  font-weight: 600;
  color: #fff;
  border: none;
}

.save-btn::after {
  border: none;
}

::v-deep .van-field__control {
  font-size: 14PX;line-height: 32PX;
  color: #333;
}

/* 修改 placeholder 字体大小 */
::v-deep  .van-field__control::placeholder {
  font-size: 14PX;line-height: 32PX;
  color: #999;
}
</style>